import {t} from '../../getTranslations';

export function getFormattedOver10Thousand(value: number): string {
  if (value >= 10000) {
    return t('viewer_menu_comment');
  } else {
    return Math.round(value).toString();
  }
}
